import invariant from 'react-utils/invariant';
const performanceMarkInvariant = mark => {
  invariant(typeof mark === 'object' && (typeof mark.name === 'undefined' || typeof mark.name === 'string' && mark.name.length > 0), `invalid performance mark shape ${mark && mark.name ? mark.name : mark}`);
  return true;
};
export default performanceMarkInvariant;